// @ts-nocheck
import React from 'react';
import ImageWithFallback from '../../../common/ImageWithFallback';
import icons from '../../../../constants/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface GameResultProps {
  name: string;
  packshotUrl?: string;
  appId?: string;
}

function GameResult({ name, packshotUrl, appId }: GameResultProps) {
  return (
    <>
      <ImageWithFallback
        url={packshotUrl}
        fallBackImage={
          <div className="game-img">
            <div className="icon-wrapper">
              <FontAwesomeIcon icon={icons.GAME} className="game" />
            </div>
          </div>
        }
        alt={name}
      ></ImageWithFallback>
      <div className="item-content">
        <span>{name}</span>
        <br />
        {appId}
      </div>
    </>
  );
}

export default GameResult;
